import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { appStore, useMapOverlay } from 'components/map';
import { locationSearchAtom } from './atoms';
import type { SearchLocations } from './coordinate-utils';
import { CoordinatePinsTool } from './coordinate-pins-tool';
import { PinMarkers } from './pin-markers';

/**
 * What each map draws: the pins, and the tool for dropping them.
 *
 * @return {JSX.Element} The pins and the tool.
 */
function CoordinatePinsOnMap(): JSX.Element {
  return (
    <>
      <PinMarkers />
      <CoordinatePinsTool />
    </>
  );
}

/**
 * Puts the Coordinates tool and the dropped pins on every map in the app. Mount it
 * once, above the pages — the app shell does.
 *
 * @param {object} props - Component props.
 * @param {SearchLocations} [props.searchLocations] - Finds wells and places for the
 *   Location field; without it the field takes coordinates only.
 * @return {null} Nothing of its own.
 */
export function CoordinatePinsOverlay({
  searchLocations,
}: {
  searchLocations?: SearchLocations;
}): null {
  useMapOverlay({ id: 'coordinate-pins', component: CoordinatePinsOnMap });
  const setSearch = useSetAtom(locationSearchAtom, appStore);
  useEffect(() => {
    setSearch(searchLocations ? { search: searchLocations } : null);
    return () => setSearch(null);
  }, [searchLocations, setSearch]);
  return null;
}
